import { render, staticRenderFns } from "./HotSearch.vue?vue&type=template&id=201f6407&scoped=true"
import script from "./HotSearch.vue?vue&type=script&lang=js"
export * from "./HotSearch.vue?vue&type=script&lang=js"
import style0 from "./HotSearch.vue?vue&type=style&index=0&id=201f6407&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201f6407",
  null
  
)

export default component.exports